<template>
  <div :class="divWidthChange" class="conteudoWidth fccGrupos">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row buttonsOptions">
      <div class="col-sm-12">
        <button
          v-b-tooltip.hover
          title="Voltar"
          @click="$router.push({ path: '/seguranca/grupos' })"
          class="btn btn-light border shadow-sm ml-2 text-dark"
        >
          <font-awesome-icon icon="chevron-left" />
        </button>
        <button
          v-b-tooltip.hover
          title="Temporário"
          @click="editTemporario(pgperid)"
          class="btn btn-light border shadow-sm ml-2 text-dark"
          v-if="grupo.pertemporario"
        >
          <font-awesome-icon icon="calendar" />
        </button>
        <button
          v-b-tooltip.hover
          title="Editar"
          @click="editGrupoPage(pgperid)"
          class="btn btn-light border shadow-sm ml-2 text-dark"
        >
          <font-awesome-icon icon="edit" />
        </button>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-sm-12">
        <b-nav class="navPermissoes">
          <b-nav-item :active="pagina === 'usuarios'" @click="pagina = 'usuarios'"
            >Usuários</b-nav-item
          >
          <b-nav-item
            :active="pagina === 'grupos'"
            @click="pagina = 'grupos'"
            :disabled="grupoExterno"
            >Grupos / Exceções</b-nav-item
          >
        </b-nav>
      </div>
    </div>
    <hr />
    <div v-if="pagina === 'usuarios'">
      <div class="row innerPage">
        <div class="col-sm-6">
          <span class="titlePage">Usuários</span>
        </div>
      </div>
      <div class="row resultadoNome">
        <div class="col-sm-12 col-xl-6">
          <div class="row">
            <div class="col-sm-8">
              <v-select
                :options="lstUser"
                v-model="usuarioNome"
                class="selectSPI"
                label="usuid"
                @input="incluiPerfilUsuario(usuarioNome)"
                placeholder="Selecione um usuário"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!usuarioNome"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 mt-3">
          <fccTable
            striped
            hover
            :fields="fieldsUser"
            responsive
            :porPage="itemPorPage"
            :titlePage="titlePage"
            :titlePDF="titlePDF"
            :actions="actionsUser"
            :items="listaUsuarios"
            empty-text="Não existem usuários"
          ></fccTable>
        </div>
      </div>
    </div>
    <div v-if="pagina === 'grupos'">
      <div class="row innerPage">
        <div class="col-sm-6">
          <span class="titlePage">Grupos</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-8">
          <v-select
            :options="listaGrupos"
            v-model="grupoSelecionado"
            class="selectSPI"
            label="pernome"
            @input="addSub"
            placeholder="Selecione um SubGrupo"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                :required="!grupoSelecionado"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-select>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fieldsSub"
            responsive
            :porPage="itemPorPage"
            :titlePage="titlePage"
            :titlePDF="titlePDF"
            :actions="actionsSub"
            :items="listaSubgrupos"
            empty-text="Não existem grupos"
          >
          </fccTable>
        </div>
      </div>
      <hr />
      <div class="row innerPage">
        <div class="col-sm-6">
          <span class="titlePage">Exceções</span>
        </div>
      </div>
      <div class="row lstExcecoes">
        <div class="col-sm-12">
          <b-table
            :fields="fieldsExcecao"
            :items="listaExcecoes"
            :show-empty="true"
            empty-text="Não existem exceções"
          >
            <template v-slot:cell(pergruexcativo)="user">
              <toggle-button
                v-model="user.item.pergruexcativo"
                @change="excecao(user.item)"
                :sync="true"
              />
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="editTemporario"
      size="lg"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="adicionandoDatas()" autocomplete="off">
        <div class="row datasTemporario">
          <div class="col-sm-5">
            Data Inicio (*)
            <datetime
              v-model="data.acetemdatainicio"
              type="datetime"
              :min-datetime="dataAtualSGP"
              format="dd/MM/yyyy HH:mm"
              class="form-control"
              placeholder="__/__/____"
              required
            ></datetime>
          </div>
          <div class="col-sm-5">
            Data Fim (*)
            <datetime
              input-id="dataInicio"
              v-model="data.acetemdatafinal"
              :min-datetime="dataAtualSGP"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              class="form-control"
              placeholder="__/__/____"
              required
            ></datetime>
          </div>
          <div class="col-sm-2 buttonAdd">
            <button
              v-b-tooltip.hover
              title="Adicionar"
              class="btn btn-light border shadow-sm ml-2 text-dark"
            >
              <font-awesome-icon icon="plus" />
            </button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-sm-12">
          <b-table
            :fields="fieldsDatas"
            :items="listaDatas"
            :show-empty="true"
            empty-text="Não existem datas"
          >
            <template v-slot:cell(acetemdatainicio)="dataInicial">
              {{ dataInicial.item.acetemdatainicio | moment('DD/MM/YYYY HH:MM:ss') }}
            </template>
            <template v-slot:cell(acetemdatafinal)="dataFinal">
              {{ dataFinal.item.acetemdatafinal | moment('DD/MM/YYYY HH:MM:ss') }}
            </template>
            <template v-slot:cell(acetemativo)="ativo">
              <toggle-button
                v-model="ativo.item.acetemativo"
                @change="editandoDataTemporario(ativo.item)"
                :sync="true"
              />
            </template>
            <template v-slot:cell(actionsTemp)="data">
              <button
                @click="excluindoDataTemporario(data.item)"
                v-b-tooltip.hover
                class="btn btn-light border shadow-sm ml-2 text-dark"
                title="Excluir"
                type="button"
              >
                <font-awesome-icon icon="trash" size="lg" />
              </button>
            </template>
          </b-table>
        </div>
      </div>
    </fccModal>
    <fccModal
      centered
      idModal="removeUser"
      size="xl"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <div class="row">
        <div class="col-sm-12">
          <b-table
            :fields="fieldsExcecao"
            :items="listaUserSub"
            :show-empty="true"
            empty-text="Não existem usuários"
          >
            <template v-slot:cell(pergruexcativo)="ativo">
              <toggle-button
                v-model="ativo.item.pergruexcativo"
                @change="excecao(ativo.item)"
                :sync="true"
              />
            </template>
          </b-table>
        </div>
      </div>
    </fccModal>
    <fccModal
      centered
      idModal="editGrupoPage"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      size="lg"
      travaBack
    >
      <form @submit.prevent="editandoGrupoPage()" autocomplete="off">
        <div class="row innerPage">
          <input type="hidden" v-model="grupo.perid" />
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="grupo.pernome" required>Nome</fccInput>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="grupo.perdescricao" required
              >Descrição</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-3">
            <label>Ativo</label><br />
            <toggle-button v-model="grupo.perativo" />
          </div>
          <div class="col-sm-3">
            <label>Temporário</label><br />
            <toggle-button v-model="grupo.pertemporario" />
          </div>
          <div class="col-sm-3">
            <label>Setor</label><br />
            <toggle-button v-model="grupo.perflsetor" />
          </div>
          <div class="col-sm-3">
            <label>Externo</label><br />
            <toggle-button v-model="grupo.perexterno" :disabled="grupoExterno" />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import './assets/fccGrupos.scss'

export default {
  data() {
    return {
      fieldsSub: [
        { key: 'perid', label: 'ID', sortable: true },
        { key: 'pernome', label: 'Nome', sortable: true },
        { key: 'actions', label: '' }
      ],
      actionsSub: [
        {
          button: true,
          funcaoButton: 'removeUser',
          icon: 'users',
          tooltip: 'Usuários',
          objpermCodigo: store.state.permissaoMenu.excluir
        },
        {
          button: true,
          funcaoButton: 'deleteSubGrupo',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsUser: [
        { key: 'usuid', label: 'ID', sortable: true },
        { key: 'usucompnome', label: 'Nome', sortable: true },
        { key: 'actions', label: '' }
      ],
      fieldsExcecao: [
        { key: 'usuid', label: 'ID', sortable: true },
        { key: 'usucompnome', label: 'Nome', sortable: true },
        { key: 'pergruexcativo', label: 'Exceção' }
      ],
      actionsUser: [
        {
          button: true,
          funcaoButton: 'deletePerfilGrupo',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsDatas: [
        { key: 'acetemdatainicio', label: 'Data inicio' },
        { key: 'acetemdatafinal', label: 'Data final' },
        { key: 'acetemativo', label: 'Status' },
        { key: 'actionsTemp', label: '' }
      ],
      fechaPesquisa: '',
      sortBy: 'ordem',
      titlePage: 'Grupos',
      titleModal: '',
      subgrupo: {},
      grupo: {},
      dataAtualSGP: this.capturaDataAtualSGP(),
      idRaiz: '',
      horaInicial: '',
      horaFinal: '',
      usuarioNome: '',
      pagina: 'usuarios',
      listaUrl: store.state.albumfamilia,
      userIcon: './src/imagens/user-icon.svg',
      listaSub: '',
      data: [],
      formActive: 0,
      grupoExterno: false,
      nomeGrupo: '',
      grupoSelecionado: '',
      titlePDF: 'Grupos',
      listaSubgrupos: [],
      listaExcecoes: [],
      listaDatas: [],
      lstUser: [],
      listaUsuarios: [],
      listaUsuariosSubGrupo: [],
      listaUserSub: [],
      listaIntranet: [],
      listaGrupos: [],
      itemPorPage: '100'
    }
  },
  methods: {
    editGrupoPage: function (item) {
      this.titleModal = 'Editar Grupo'
      this.pgperid = item
      this.$root.$emit('bv::show::modal', 'editGrupoPage')
    },
    adicionandoDatas: function () {
      if (this.data.acetemdatafinal < this.data.acetemdatainicio) {
        this.callAlert('Erro ao Inserir', 'Data final maior que a data inicial', 'error', 'error')
      } else {
        var datas = {
          acetemid: 0,
          perid: this.pgperid,
          acetemdatainicio: this.data.acetemdatainicio,
          acetemdatafinal: this.data.acetemdatafinal,
          acetemativo: true
        }
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .post(
            this.baseUrlSeguranca + 'AcessoTemporario/incluiracessoTemporario',
            datas,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.data.acetemdatainicio = this.dataHoraTipoSGP('08:00')
            this.data.acetemdatafinal = this.dataHoraTipoSGP('17:00')
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.editado, 'success')
            this.listarDatasTemporario()
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      }
    },
    listarDatasTemporario: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'AcessoTemporario/listarAcessoTempPorGrupo' + this.pgperid,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaDatas = response.data
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoUser: function () {
      const endpoint = this.grupoExterno
        ? 'Cadastro/listartodosloginexterno'
        : 'Cadastro/listartodoslogininterno'
      axios
        .get(this.baseUrlSecurity + endpoint, this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.lstUser = response.data
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
    },
    excluindoDataTemporario: function (item) {
      this.callConfirm(this.mensagemExcluir, '').then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSeguranca +
                'AcessoTemporario/excluiracessoTemporario?acessoTemporarioID=' +
                item.acetemid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarDatasTemporario()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    editandoDataTemporario: function (item) {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrlSeguranca + 'AcessoTemporario/alteraracessoTemporario',
          item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarDatasTemporario()
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editTemporario: function () {
      this.titleModal = 'Editar datas'
      this.data.acetemdatainicio = this.dataHoraTipoSGP('08:00')
      this.data.acetemdatafinal = this.dataHoraTipoSGP('17:00')
      this.listarDatasTemporario()
      this.$root.$emit('bv::show::modal', 'editTemporario')
    },
    editandoGrupoPage: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrlSeguranca + 'Perfil/alterarperfil',
          this.grupo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarGrupoAtual()
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editGrupoPage')
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    excecao: function (item) {
      if (item.pergruexcativo === true && item.pergruexcid === 0) {
        axios
          .post(
            this.baseUrlSeguranca + 'Perfil/incluirperfilgrupoexcecao',
            item,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.callToast(this.mensagensUpdate.excluido, 'success')
            this.listandoExcecoes()
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      } else {
        axios
          .put(
            this.baseUrlSeguranca + 'Perfil/alterarperfilgrupoexcecao',
            item,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.callToast(this.mensagensUpdate.editado, 'success')
            this.listandoExcecoes()
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      }
    },
    removeUser: function (_, item) {
      this.listarPerfilUsuario(item.perid, 1)
      this.titleModal = 'Usuários do Grupo ' + item.pernome
      this.$root.$emit('bv::show::modal', 'removeUser')
    },
    addSub: function () {
      if (
        this.listaSubgrupos.find((subItem) => subItem.perid === this.grupoSelecionado.perid) ===
        undefined
      ) {
        var item = {
          pergruid: 0,
          perid: this.grupoSelecionado.perid,
          pergrupraizid: this.idRaiz,
          pergruativo: true,
          pernome: this.grupoSelecionado.pernome,
          perdescricao: this.grupoSelecionado.perdescricao,
          pergruraiznome: this.nomeGrupo
        }
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .post(
            this.baseUrlSeguranca + 'Perfil/incluirperfilgrupo',
            item,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.subgrupo = {}
            this.listandoSubgrupos()
            this.callToast(this.mensagensUpdate.editado, 'success')
            this.$root.$emit('bv::hide::modal', 'editGrupo')
            this.carregaTexto()
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      }
    },
    listarPerfilUsuario(id, sub = null, loading = false) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'Perfil/listarusuariogrupoporpai/' + id,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          if (sub === null) {
            this.listaUsuarios = response.data
          } else {
            this.listaUsuariosSubGrupo = []
            this.listaUsuariosSubGrupo = response.data
            this.listaUserSub = []
            if (this.listaUsuariosSubGrupo) {
              for (var listando of Object.values(this.listaUsuariosSubGrupo)) {
                var item = {
                  pergruexcid: 0,
                  usuid: listando.usuid,
                  perid: this.pgperid,
                  usucompnome: listando.usucompnome,
                  pergruexcativo: false
                }
                if (
                  this.listaExcecoes.find(
                    (subGrupo) =>
                      subGrupo.usuid === listando.usuid && subGrupo.pergruexcativo === true
                  ) !== undefined
                ) {
                  var grupo = this.listaExcecoes.find(
                    (subExcecao) => subExcecao.usuid === listando.usuid
                  )
                  item.pergruexcid = grupo.pergruexcID
                  item.pergruexcativo = true
                }
                this.listaUserSub.push(item)
              }
            }
          }
          if (!loading) {
            this.carregaTexto()
          }
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto)
    },
    incluiPerfilUsuario: function (item) {
      if (this.listaUsuarios.find((user) => user.usuid === item.usuid) === undefined) {
        const usuarioPerfil = {
          perusuid: 0,
          perid: this.pgperid,
          usuid: item.usuid
        }
        this.carregaTexto(this.codeMensagem('C05'))
        axios
          .post(
            this.baseUrlSeguranca + 'Perfil/incluirperfilusuario',
            usuarioPerfil,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.subgrupo = {}
            this.carregaTexto()
            this.listarPerfilUsuario(this.pgperid)
            this.limpaIntra()
            this.callToast(this.mensagensUpdate.adicionado, 'success')
            this.$root.$emit('bv::hide::modal', 'editGrupo')
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      } else {
        this.callAlert(item.usucompnome, 'Usuário já adicionado', 'error', 'error')
        this.limpaIntra()
      }
    },
    listandoLogin: function (username) {
      if (username.length === 0) {
        this.limpaIntra()
      }
      if (username.length >= 4) {
        axios
          .get(
            this.baseUrlSeguranca + 'Cadastro/listarloginpornome/' + username,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            this.listaIntranet = response.data
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      } else {
        this.fechaPesquisa = ''
      }
    },
    limpaIntra: function () {
      this.listaIntranet = []
      this.usuarioNome = ''
    },
    deleteSubGrupo: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.pernome).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSeguranca + 'Perfil/excluirperfilgrupo?pergruID=' + item.pergruid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoSubgrupos()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    deletePerfilGrupo: function (_, item) {
      this.callConfirm(
        this.mensagemExcluir,
        item.usucompnome === null ? '' : item.usucompnome
      ).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSeguranca + 'Perfil/excluirperfilusuario?PerusuID=' + item.perusuid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarPerfilUsuario(this.pgperid)
              this.carregaTexto()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.carregaTexto()
              this.setErrorSystem(error)
            })
        }
      })
    },
    listandoGrupos: function () {
      axios
        .get(this.baseUrlSeguranca + 'Perfil/listarperfil', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listaGrupos = response.data
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
    },
    listarGrupoAtual: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'Perfil/listarperfilporidnome?perID=' + this.pgperid,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.grupoExterno = response.data[0].perexterno
          this.idRaiz = response.data[0].pergruraizid
          this.grupo = response.data[0]
          if (this.idRaiz === 0) {
            var camposPerfilGrupoRaiz = {
              pergruraizid: 0,
              perid: this.pgperid,
              pergruraiznome: response.data[0].pernome,
              pergruraizAtivo: true
            }
            axios
              .post(
                this.baseUrlSeguranca + 'Perfil/incluirperfilgruporaiz',
                camposPerfilGrupoRaiz,
                this.dadosLoginSession.fccTokenHeaders
              )
              .then((responseData) => {
                this.idRaiz = responseData.data
              })
          }
          this.listandoGrupos()
          this.listandoSubgrupos()
          this.listandoExcecoes()
          this.listandoUser()

          this.nomeGrupo = response.data[0].pernome
          this.titlePage = 'Grupo ' + response.data[0].pernome
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoSubgrupos: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'Perfil/listarperfilgrupoporraiz/' + this.idRaiz,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaSubgrupos = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listandoExcecoes: function () {
      axios
        .get(
          this.baseUrlSeguranca + 'Perfil/listarperfilgrupoexcecaoporgrupo/' + this.pgperid,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaExcecoes = response.data
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  created() {
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranca
    this.pgperid = this.$route.params.id
    this.listarGrupoAtual()
    this.listarPerfilUsuario(this.pgperid, null, true)
  }
}
</script>
